// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuLabel_root__3TVbT","clickedWithMouse":"MenuLabel_clickedWithMouse__1aWVd","isOpen":"MenuLabel_isOpen__2nsqC"};